// src/common/components/toggle/Toggle.tsx

import React from 'react'
import styles from './Toggle.module.scss'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  small?: boolean
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  small = false,
}) => {
  return (
    <label
      className={`${styles.switch} ${small ? styles.small : ''} ${disabled ? styles.disabled : ''}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className={`${styles.slider} ${checked ? styles.checked : ''}`} />
    </label>
  )
}
